import http, {objectToFormData} from './http';

export default {
  all() {
    return http().get(`/v2/answering_sequence_steps`);
  },
  get(id) {
    return http().get(`/v2/answering_sequence_steps/${id}`);
  },
  create(data, validationErrors = {}) {
    return http(validationErrors).post(`/v2/answering_sequence_steps`, data);
  },
  update(data, validationErrors = {}) {
    return http(validationErrors).put(`/v2/answering_sequence_steps/${data.id}`, data);
  },
  updateOrder(data) {
    return http().post(`v2/answering_sequence_steps/update_order`, data);
  },
  delete(id) {
    return http().delete(`/v2/answering_sequence_steps/${id}`);
  },
}
